// src/Delete.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Delete_default = createIcon({
  displayName: "Delete",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { opacity: "0", width: "24", height: "24", fill: "white", fillOpacity: "0" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M5.33643 4.00058C4.79518 4.00072 4.30797 4.32891 4.1043 4.83057C3.90063 5.33222 4.02111 5.9073 4.40899 6.28494L10.1191 11.9971L4.40899 17.7093C4.06151 18.0431 3.92154 18.5386 4.04305 19.0049C4.16457 19.4712 4.52859 19.8354 4.99471 19.9569C5.46084 20.0785 5.95624 19.9385 6.28985 19.5909L12 13.8787L17.7101 19.5909C18.0438 19.9385 18.5392 20.0785 19.0053 19.9569C19.4714 19.8354 19.8354 19.4712 19.9569 19.0049C20.0785 18.5386 19.9385 18.0431 19.591 17.7093L13.8809 11.9971L19.591 6.28494C19.9844 5.9024 20.1027 5.31751 19.8889 4.81209C19.675 4.30667 19.173 3.9844 18.6246 4.00058C18.279 4.01088 17.9511 4.15536 17.7101 4.4034L12 10.1156L6.28985 4.4034C6.03943 4.14588 5.69556 4.0006 5.33643 4.00058Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      }
    )
  ] })
});

export {
  Delete_default
};
